import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Label,
  Modal
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import Alert from "../../../components/alert/Alert";
import { createHashHistory } from "history";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import {
  get_site_details,
  update_site,
  installssl,
} from "../../../redux/actions/siteActions";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import auth               from '../../../services/auth';
import {aclUtil} from "../../util"

const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
    reader.readAsDataURL(file);
  });
};
const history = createHashHistory();

class EditSite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'EDIT_SITE',
      siteID: "",
      siteName: "",
      siteDomain: "",
      siteLogo: "",
      filename: "",
      locAddress1: "",
      locAddress2: "",
      locCity: "",
      locState: "",
      locStateAbbr: "",
      locCountry: "",
      locCountryName: "",
      locLatitude: "",
      locLongitude: "",
      locPhone: "",
      siteDealMethod: "",
      credit_card_fee: "",
      facebookPage: "",
      twitterPage: "",
      taxes: "enable",
      siteStatus: "",
      msgType: "",
      alertMessage: "",
      loccityID: "",
      locCountryError: false,
      locCityError: false,
      locStateError: false,
      uploadFile: false,
      customer_email_support: '',
      partner_support_email: '',
      reply_to_address: '',
      admin_email: '',
      pending_offers: 'disable',
      prior_hours_pending_offers: '',
      search_location: '',
      search_deals: '',
      charity: 'disable',
      sslshow: false,
      certificate: '',
      privatekey: '',
      certificatechain: '',
      button_text: "Install",
      disabled: false,
      youtube_link: "",
      insta_link: "",

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadSiteDetails = this.loadSiteDetails.bind(this);
    this.handleInstallSSL = this.handleInstallSSL.bind(this);
    this.handleInstallSSLClose = this.handleInstallSSLClose.bind(this);
    this.handleInstall = this.handleInstall.bind(this);
  }

  loadSiteDetails = () => {
    let user = auth.getUserInfo()  ? auth.getUserInfo() : null;
    this.props.get_site_details(user.siteID);
  };
  componentWillMount() {
    this.loadSiteDetails();
  }

  handleInstallSSLClose() {
    this.setState({ sslshow: false, siteID: '', certificate: '', privatekey: '', certificatechain: '' });
  }
  validateCertificate(){
    let status = true;

    if(this.state.certificate === ''){
      status = false;
      this.setState({certificateError: 'red'});
    }

    if(this.state.privatekey === ''){
      status = false;
      this.setState({privatekeyError: 'red'});
    }

    if(this.state.certificatechain === ''){
      status = false;
      this.setState({certificatechainError: 'red'});
    }
    return status;
  }

  handleInstall = (e) => {
    e.preventDefault();
    let valid = this.validateCertificate();
    if(valid){
      this.setState({button_text: "Installing....", disabled: true});
      let postData = {
        siteID: this.state.siteID,
        certificate: this.state.certificate,
        privatekey: this.state.privatekey,
        certificatechain: this.state.certificatechain
      }

      this.props.installssl(postData);
    }
  }

  handleInstallSSL(siteID){
    this.setState({siteID: siteID, sslshow: true});
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }
    
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        if(this.state.sslshow){
          this.setState({button_text: "Install", disabled: false});
          this.handleInstallSSLClose();
        }
        this.setState({ alertMessage: nextProps.error, msgType: "warning" });
        window.scrollTo(0, 0);
      }
    }

    if (this.props.ssl !== nextProps.ssl) {
      if (nextProps.ssl) {
        if(this.state.sslshow){
          this.setState({button_text: "Install", disabled: false});
          this.handleInstallSSLClose();
        }
        this.setState({ alertMessage: nextProps.ssl.message, msgType: "success" });
        window.scrollTo(0, 0);
      }
    }

    if (this.props.updatedSiteDetails !== nextProps.updatedSiteDetails) {
      if (!isEmpty(nextProps.updatedSiteDetails)) {
        this.setState({
          alertMessage:
            nextProps.updatedSiteDetails.message &&
            nextProps.updatedSiteDetails.message,
          msgType: "success"
        });
        this.loadSiteDetails();
        window.scrollTo(0, 0);
      }
    }

    if (this.props.siteDetails !== nextProps.siteDetails) {
      if (nextProps.siteDetails) {
        let site = nextProps.siteDetails;
        this.setState({
          id: site.id,
          siteDealMethod: site.siteDealMethod,
          locAddress1: site.locAddress1,
          locAddress2: site.locAddress2,
          locCity: site.locCity,
          locCountry: site.locCountry,
          locLatitude: site.locLatitude,
          locLongitude: site.locLongitude,
          locPhone: site.locPhone,
          locState: site.locState,
          siteDomain: site.siteDomain,
          siteID: site.siteID,
          siteLogo: site.siteLogo,
          filename: site.siteLogo,
          siteName: site.siteName,
          siteStatus: site.status,
          loccityID: site.locCityID,
          locStateAbbr: site.locStateName,
          credit_card_fee: site.credit_card_fee,
          facebookPage: site.facebookPage,
          twitterPage: site.twitterPage,
          youtube_link: site.youtube_link,
          insta_link: site.insta_link,
          taxes: site.taxes,
          customer_email_support: site.customer_email_support,
          partner_support_email: site.partner_support_email,
          reply_to_address: site.reply_to_address,
          admin_email: site.admin_email,
          pending_offers: site.pending_offers,
          prior_hours_pending_offers: site.prior_hours_pending_offers,
          search_location: site.search_location,
          search_deals: site.search_deals,
          charity: site.charity,
        });
      }
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  addFile = (e: any): void => {
    let file = e.target.files[0];
    getBase64(file).then(base64 => {
      localStorage.setItem("fileBase64", base64);

      this.setState({ siteLogo: localStorage.getItem("fileBase64") });
    });
    this.setState({ filename: file.name, uploadFile: true });
  };

  handleSubmit(e) {
    e.preventDefault();
    const updateData = {
      siteID: this.state.siteID,
      siteName: this.state.siteName,
      siteDomain: this.state.siteDomain,
      siteLogo: this.state.siteLogo,
      filename: this.state.filename,
      locAddress1: this.state.locAddress1,
      locAddress2: this.state.locAddress2,
      locCity: this.state.locCity,
      locState: this.state.locState,
      locCountry: this.state.locCountry,
      locLatitude: this.state.locLatitude,
      locLongitude: this.state.locLongitude,
      locPhone: this.state.locPhone,
      siteDealMethod: this.state.siteDealMethod,
      siteStatus: this.state.siteStatus,
      loccityID: this.state.loccityID,
      credit_card_fee: this.state.credit_card_fee,
      facebookPage: this.state.facebookPage,
      twitterPage: this.state.twitterPage,
      youtube_link: this.state.youtube_link,
      insta_link: this.state.insta_link,
      taxes: this.state.taxes,
      customer_email_support: this.state.customer_email_support,
      partner_support_email: this.state.partner_support_email,
      reply_to_address: this.state.reply_to_address,
      admin_email: this.state.admin_email,
      pending_offers: this.state.pending_offers,
      prior_hours_pending_offers: this.state.prior_hours_pending_offers,
      search_location: this.state.search_location,
      search_deals: this.state.search_deals,
      charity: this.state.charity,
    };
    this.props.update_site(updateData);
  }

  onSelectedCountry = (val, key) => {
    this.setState({ locCountry: val });
    this.setState({ locCountryName: key });
    if(this.state.locCountry != val){
      this.setState({locState: '', locStateAbbr: '', locCity: '', loccityID: ''});
    }
  };

  onSelectedState = (val, key) => {
    this.setState({ locState: val });
    this.setState({ locStateAbbr: key });
  };

  onSelectedCity = (val, key) => {
    this.setState({ locCity: val });
    this.setState({ loccityID: key });
  };

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        <div className="row">
          {(this.state.alertMessage !== "" || this.props.error) && (
            <div className="col-lg-12">
              <Notification type={this.state.msgType}>
                <span>
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage || this.props.error}
                </span>
              </Notification>
            </div>
          )}
        </div>
        <form onSubmit={this.handleSubmit}>
        <div className="panel">
          <header className="panel-heading">Company Information {aclUtil.checkACL('IMPORT_SSL') ? (<a className="pull-right btn btn-success" onClick={this.handleInstallSSL.bind(this, localStorage.getItem("siteID"))}>Install SSL/TLS</a>):("")}</header>
          <div className="panel-body">
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formBasicSiteNameText">
                      <ControlLabel>Site Name</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.siteName}
                        placeholder="Enter Site Name"
                        onChange={this.handleChange}
                        name="siteName"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicSiteDomainText">
                      <ControlLabel>Site Domain</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.siteDomain}
                        placeholder="Enter Site Domain"
                        onChange={this.handleChange}
                        name="siteDomain"
                      />
                    </FormGroup>
                    {/*<FormGroup>
                      <ControlLabel
                        htmlFor="fileUpload"
                        style={{ cursor: "pointer" }}
                      >
                        <h3>
                          <Label bsStyle="success">Upload Image File</Label>
                        </h3>
                        <FormControl
                          id="fileUpload"
                          type="file"
                          accept="image/*"
                          onChange={this.addFile}
                          style={{ display: "none" }}
                        />
                        {this.state.filename}
                      </ControlLabel>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel htmlFor="showfileUpload">
                        {this.state.siteLogo !== "" && (
                          <img
                            alt="Select an image"
                            height="50px"
                            width="50px"
                            src={
                              this.state.uploadFile
                                ? this.state.siteLogo
                                : this.state.siteLogo
                            }
                          />
                        )}
                      </ControlLabel>
                    </FormGroup>*/}
                    <div className="form-group">
                      <CountryStateCity
                        onSelectedCountry={this.onSelectedCountry}
                        onSelectedState={this.onSelectedState}
                        onSelectedCity={this.onSelectedCity}
                        country={this.state.locCountry}
                        stateAbbr={this.state.locState}
                        city={this.state.locCity}
                        cityId={this.state.loccityID}
                      />
                      {this.state.locCountryError ? (
                        <span style={{ color: "red" }}>Select a country! </span>
                      ) : (
                        ""
                      )}
                      {this.state.locStateError ? (
                        <span style={{ color: "red" }}>Select a state! </span>
                      ) : (
                        ""
                      )}
                      {this.state.locCityError ? (
                        <span style={{ color: "red" }}>Select a city! </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <FormGroup controlId="formBasicCardFeeText">
                      <ControlLabel>Credit Card Fee</ControlLabel>
                      <FormControl
                        type="number"
                        value={this.state.credit_card_fee}
                        placeholder="Enter Credit Card Fee"
                        onChange={this.handleChange}
                        name="credit_card_fee"
                      />
                    </FormGroup>
                    <FormGroup controlId="formControlsIsEnableTaxSelect">
                      <ControlLabel>Enable taxes</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="taxes"
                        value={this.state.taxes}
                        onChange={this.handleChange}
                      >
                        <option value="enable">Yes</option>
                        <option value="disable">No</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formBasicLocalAddressOneText">
                      <ControlLabel>Site Location Address1</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.locAddress1}
                        placeholder="Enter Local Address"
                        onChange={this.handleChange}
                        name="locAddress1"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicLocalAddressTwoText">
                      <ControlLabel>Site Location Address2</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.locAddress2}
                        placeholder="Enter Site Location Address"
                        onChange={this.handleChange}
                        name="locAddress2"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicLocPhoneText">
                      <ControlLabel>Site Location Phone</ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.locPhone) ? this.state.locPhone : ''}
                        placeholder="Enter Site Location Phone"
                        onChange={this.handleChange}
                        name="locPhone"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formBasicLocationLatitudeText">
                      <ControlLabel>Site Location Latitude</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.locLatitude}
                        placeholder="Enter Site Location Latitude"
                        onChange={this.handleChange}
                        name="locLatitude"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicLocationLongitudeText">
                      <ControlLabel>Site Location Longitude</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.locLongitude}
                        placeholder="Enter Site Location Longitude"
                        onChange={this.handleChange}
                        name="locLongitude"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicFbLinkText">
                      <ControlLabel>Facebook Link</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.facebookPage}
                        placeholder="Enter Facebook Link"
                        onChange={this.handleChange}
                        name="facebookPage"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicTwitterLinkText">
                      <ControlLabel>Twitter Link</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.twitterPage}
                        placeholder="Enter Twitter Link"
                        onChange={this.handleChange}
                        name="twitterPage"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicYtLinkText">
                      <ControlLabel>Youtube Link</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.youtube_link}
                        placeholder="Enter Youtube Link"
                        onChange={this.handleChange}
                        name="youtube_link"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicInstagramWLinkText">
                      <ControlLabel>Instagram Link</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.insta_link}
                        placeholder="Enter Instagram Link"
                        onChange={this.handleChange}
                        name="insta_link"
                      />
                    </FormGroup>
                    <FormGroup controlId="formControlsIsLocationBasicSelect">
                      <ControlLabel>Geolocation Enable</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="siteDealMethod"
                        value={this.state.siteDealMethod}
                        onChange={this.handleChange}
                      >
                        <option value="LatLong">Yes</option>
                        <option value="City">No</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formControlsSiteStatusSelect">
                      <ControlLabel>Site Status</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="siteStatus"
                        value={this.state.siteStatus}
                        onChange={this.handleChange}
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive"> Inactive </option>
                      </FormControl>
                    </FormGroup>
                    
                  </Col>               
              </Row>
            </div>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Company Email List</header>
          <div className="panel-body">
            <Row>
              <Col md={6} xs={12}>
                <FormGroup controlId="formControlsReplyToAddress">
                  <ControlLabel>ReplyTo Address</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.reply_to_address}
                    placeholder="Enter ReplyTo Address"
                    onChange={this.handleChange}
                    name="reply_to_address"
                  />
                </FormGroup>
                <FormGroup controlId="formControlsAdminEmail">
                  <ControlLabel>Admin Email</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.admin_email}
                    placeholder="Enter Admin Email"
                    onChange={this.handleChange}
                    name="admin_email"
                  />
                </FormGroup>
                
              </Col>
              <Col md={6} xs={12}>
                <FormGroup controlId="formControlsCustomerSupportEmail">
                  <ControlLabel>Customer Support Email</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.customer_email_support}
                    placeholder="Enter Customer Support Email"
                    onChange={this.handleChange}
                    name="customer_email_support"
                  />
                </FormGroup>
                <FormGroup controlId="formControlsPartnerSupportEmail">
                  <ControlLabel>Partner Support Email</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.partner_support_email}
                    placeholder="Enter Partner Support Email"
                    onChange={this.handleChange}
                    name="partner_support_email"
                  />
                </FormGroup>
              </Col>
            </Row>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Offer Setting</header>
          <div className="panel-body">
            <Row>
              <Col md={6} xs={12}>
                <FormGroup controlId="formControlsPendingStatus">
                  <ControlLabel>Pending Offer Status</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="pending_offers"
                    value={this.state.pending_offers}
                    onChange={this.handleChange}
                  >
                    <option value="enable">Enable</option>
                    <option value="disable">Disable</option>
                  </FormControl>
                </FormGroup>               
              </Col>
              <Col md={6} xs={12}>
                <FormGroup controlId="formControlsPendingHours">
                  <ControlLabel>How many hours prior to going live should the offer be visible?</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.prior_hours_pending_offers}
                    placeholder="Enter Hours"
                    onChange={this.handleChange}
                    name="prior_hours_pending_offers"
                    disabled={(this.state.pending_offers == 'disable') ? true : false}
                  />
                  <span style={{fontSize:'12px', color:'#666'}}>(If left blank then offers will show from the time they are in the Pending section til live.)</span>
                </FormGroup>
              </Col>
            </Row>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Turn on/off search and location otpion on mobile</header>
          <div className="panel-body">
            <Row>
              <Col md={6} xs={12}>
                <FormGroup controlId="formControlsOfferStatus">
                  <ControlLabel>Search Option</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="search_deals"
                    value={this.state.search_deals}
                    onChange={this.handleChange}
                  >
                    <option value="on">ON</option>
                    <option value="off">OFF</option>
                  </FormControl>
                </FormGroup>               
              </Col>
              <Col md={6} xs={12}>
                <FormGroup controlId="formControlsOfferStatus">
                  <ControlLabel>Location Option</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="search_location"
                    value={this.state.search_location}
                    onChange={this.handleChange}
                  >
                    <option value="on">ON</option>
                    <option value="off">OFF</option>
                  </FormControl>
                </FormGroup> 
              </Col>
            </Row>
            <Row>
              <Col md={6} xs={12}>
                <FormGroup controlId="formControlsOfferStatus">
                  <ControlLabel>Charity</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="charity"
                    value={this.state.charity}
                    onChange={this.handleChange}
                  >
                    <option value="enable">Enable</option>
                    <option value="disable">Disable</option>
                  </FormControl>
                </FormGroup> 
              </Col>
            </Row>
            <Row>
            <Col md={12} xs={12}>
              <Button bsStyle="info" type="submit">
                Submit
              </Button>
              <Button
                bsStyle="default"
                type="button"
                onClick={() => history.push(`/editSite`)}
              >
                Cancel
              </Button>
            </Col>
            </Row>
          </div>
        </div>
        </form>
        <Modal show={this.state.sslshow} onHide={this.handleInstallSSLClose}>
          <Modal.Header closeButton>
            <Modal.Title>Install SSL/TLS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <FormGroup controlId="formControlsCertificate">
                  <ControlLabel>Certificate</ControlLabel>
                  <FormControl 
                    componentClass="textarea" 
                    onChange={this.handleChange} 
                    rows={10} name="certificate" 
                    placeholder="Paste certificate here" 
                    style={{borderColor : this.state.certificateError}}
                  />
                </FormGroup>
              </div>
              <div className="col-lg-12">
                <FormGroup controlId="formControlsPrivate">
                  <ControlLabel>Private Key</ControlLabel>
                  <FormControl 
                    componentClass="textarea" 
                    onChange={this.handleChange} 
                    rows={10} name="privatekey" 
                    placeholder="Paste Private Key here" 
                    style={{borderColor : this.state.privatekeyError}}
                  />
                </FormGroup>
              </div>
              <div className="col-lg-12">
                <FormGroup controlId="formControlsCertificateChain">
                  <ControlLabel>Certificate Chain</ControlLabel>
                  <FormControl 
                    componentClass="textarea" 
                    onChange={this.handleChange} 
                    rows={10} 
                    name="certificatechain" 
                    placeholder="Paste Certificate Chain here" 
                    style={{borderColor : this.state.certificatechainError}}
                  />
                </FormGroup>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleInstall} disabled={this.state.disabled}>{this.state.button_text}</Button>
            <Button onClick={this.handleInstallSSLClose}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

EditSite.propTypes = {
  get_site_details: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  siteDetails: state.siteReducer.siteDetails,
  error: state.siteReducer.error,
  updatedSiteDetails: state.siteReducer.updatedSiteDetails,
  ssl: state.siteReducer.ssl
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { get_site_details, update_site, installssl })
)(EditSite);



// WEBPACK FOOTER //
// ./src/app/views/admin/manageSite/EditSite.js